import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../System/Components/Loader'
import dayjs from 'dayjs'
import AddressTable from './Components/AddressTable';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Tag } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { get, save } from '../../System/Api/API';
import { useGlobal } from '../../System/Global/GlobalProvider';
import { unescapeNested } from '../../System/Global/unescapeArray';
import { countryJson } from '../../System/Global/countryJson';

export const Bookings = () => {

    const { UserData } = useGlobal();
    const [ records, setRecords ] = useState([]);
    const [ showModal, setShowModal ] = useState(false)
    const [ dates, setDates ] = useState([dayjs().startOf('month'), dayjs().endOf('month')])
    const [selectedAddress, setSelectedAddress] = useState(null)
    const { status } = useParams();
    const navigate = useNavigate();
    
    useEffect(() => {

        loadRecords()

        return() => {
            setRecords([])
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]) 

    const loadRecords = async () => {

        // let _addresses = []//unescapeNested( await get('address_book', {clientKey: UserData.clientKey}, [{fieldName: 'name', orderDirection: 'asc'}]) )

        if (status === 'Draft') {

            let _bookings = await get('bookings_draft', {clientKey: UserData.clientKey}, [{fieldName: 'col_date', orderDirection: 'desc'}])
            _bookings = unescapeNested(_bookings)
            setRecords(_bookings)
        }

        else {

            let _bookings = []
            if (status === "Live") {
                _bookings = await get('bookings', {clientKey: UserData.clientKey, 'status <>': "Delivered"}, [{fieldName: 'col_date', orderDirection: 'desc'}])
            } else {
                _bookings = await get('bookings', {clientKey: UserData.clientKey, status: "Delivered", 'del_date >=': dayjs(dates[0]).format('YYYY-MM-DD'), 'del_date <=': dayjs(dates[1]).format('YYYY-MM-DD')}, [{fieldName: 'col_date', orderDirection: 'desc'}])
            }
            _bookings = unescapeNested(_bookings)
            setRecords(_bookings)
        }
        
        // setRecords( await fetchPurchases([dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]) )   
    }

    useEffect( () => {

        loadRecords();

    }, [dates])

    
    const columns = [
        {
            title: "Collection address",
            render: data => <div>{dayjs(data.col_date).format('DD/MM/YYYY')} - {data.col_time}<br/>{data.col_name}, {data.col_townName}, {data.col_postCode}</div>,
            key: "coladdress",
        },
        {
            title: "Delivery address",
            render: data => <div>{dayjs(data.del_date).format('DD/MM/YYYY')} - {data.del_time}<br/>{data.del_name}, {data.del_townName}, {data.del_postCode}</div>,
            key: "deladdress",
        },
        {
            title: "Vehicle",
            render: data => data.vanType,
            key: "vehicle",
        },
        {
            title: "Price",
            render: data => "£" + data.totalPrice,
            key: "price",
        },
        {
            title: "Status",
            render: data => {
                if (data.status === "Live") {
                    return <Tag color="blue">Live</Tag>;
                } else if (data.status === "Transit") {
                    return <Tag color="orange">In Transit</Tag>;
                } else if (data.status === "Delivered") {
                    return <Tag color="green">Delivered</Tag>;
                } else {
                    return data.status;
                }
            },
            key: "status",
        },
        
    ]

    const selectAddress = (record) => {

        if (status === "Draft") {
            navigate(`/bookings/draft/view/${record.bookingKey}`)
        } else {
            navigate(`/bookings/view/${record.bookingKey}`)
        }
        

    }

    const presetRanges = {
        'Last week': [
            dayjs(dayjs().startOf('week').add(-7, 'days').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('week').add(-7, 'days').format('YYYY-MM-DD'), "YYYY-MM-DD")
        ],
        'Last month' : [
            dayjs(dayjs().startOf('month').add(-1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('month').add(-1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
        ],
        'This week': [
            dayjs(dayjs().startOf('week').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('week').format('YYYY-MM-DD'), "YYYY-MM-DD")
        ],
        'This month' : [
            dayjs(dayjs().startOf('month').format('YYYY-MM-DD'), 'YYYY-MM-DD'), 
            dayjs(dayjs().endOf('month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
        ],
    }

    const exportCSVMultiline = async () => {

        let csvExportData = `Opex Ref,OrderNo,Collection Date,Collection Name,Collection Town,Delivery Date,Delivery Name, Delivery Town,Price\r\n`;

        for await (let i of records) {

            csvExportData += `${i.crgoRef},${i.orderNo},${dayjs(i.col_date).format('DD/MM/YYYY')},"${i.col_name.replace(/,/g, "")}","${i.col_townName.replace(/,/g, "")}",${dayjs(i.del_date).format('DD/MM/YYYY')},"${i.del_name.replace(/,/g, "")}","${i.del_townName.replace(/,/g, "")}",${ ( parseFloat(parseFloat(i.totalPrice || 0)).toFixed(2)).toLocaleString() }\r\n`;

        }


        // const file = new Blob([this.state.csvExportData], {type: 'text/plain'})
        const element = document.createElement("a");
        const file = new Blob([csvExportData], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = `Delivered-Bookings.csv`;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    return (
        records ?
        <div style={{padding: 20}}>
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <h2 style={{marginTop: 0, paddingLeft: 20}}>{status === "Draft" ? "Awaiting Acceptance" : `${status} Bookings`}</h2>
                </div>
                <div style={{marginRight: 20}}>
                    { status === "Delivered" &&
                    <div>
                    <DatePicker.RangePicker value={dates} format={"DD/MM/YYYY"} onChange={(dates) => setDates(dates)} ranges={presetRanges}/>
                    <Button style={{marginLeft: 10}} type="primary" onClick={exportCSVMultiline}>Download</Button>
                    </div>}
                </div>
                
            </div>

            <div style={{height: 'calc(100vh - 100px)', overflowY: 'scroll', overflowX: 'hidden'}}>
                { status === "Delivered" && <div style={{margin: 20}}>
                    <Row gutter={15}>
                        <Col xs={8}>
                            <div style={{backgroundColor: '#EFF2F5', padding: 30}}>
                                <h1>{records?.length}</h1>
                                <h4>Total Bookings</h4>
                            </div>
                        </Col>
                        <Col xs={8}>
                            <div style={{backgroundColor: '#EFF2F5', padding: 30}}>
                                <h1>£{records.reduce((sum, record) => sum + parseFloat(record.totalPrice || 0), 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h1>
                                <h4>Total Bookings</h4>
                            </div>
                        </Col>
                    </Row>
                </div> }
            <AddressTable 
                columns={columns}
                records={records} 
                row_key="bookingKey"
                selectRow={selectAddress}
            /> 
            </div>
            
        </div>
        : <Loader />
        
    )
    
}

export default Bookings;
